import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';

const Result = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const rawHtml = location.state?.html || '';

  // Sanitize the HTML before rendering
   const sanitizedHtml = rawHtml
    ? DOMPurify.sanitize(rawHtml, {
        USE_PROFILES: { html: true },
        ALLOWED_TAGS: ['div', 'span', 'h2', 'h3', 'p', 'strong', 'b', 'i', 'u', 'em', 'br', 'hr', 'ol', 'li']
      })
    : null;
    
  return (
    <main className="flex-1 flex flex-col items-center px-4 py-6">
      {/* Info Card */}
      <div className="w-full max-w-xl bg-white shadow-lg rounded-md border border-gray-300 p-6">
  
        {/* Render sanitized HTML */}
        {sanitizedHtml ? (
          <div
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          />
        ) : (
          <p className="text-red-500">No scan result found. Please scan again.</p>
        )}
      </div>
  
        <div className="hidden text-green-600" />
      {/* Back Button */}
      <div className="mt-6">
        <button
          onClick={() => navigate('/scanner')}
          style={{ backgroundColor: '#103D4B' }}
          className="inline-block px-6 py-2 text-white font-semibold rounded hover:bg-blue-700 transition"
        >
          ← Back to Scanner
        </button>
      </div>
      
    </main>
  );
  
};

export default Result;